<template>
  <div class="header-firm-container position-relative w-100 d-flex align-items-center justify-content-end me-3">
    <!-- 1. WIDGET ROȘU: FIRMA DE LUCRU (CONTABILITATE) - EXACT PE CENTRUL BAREI DE ANTET -->
    <!-- Afișat dacă utilizatorul are drepturi și modul este 'contabil' sau 'tot' -->
    <div
      v-if="showContabilSection"
      class="header-contabil-centered d-flex align-items-center"
      :class="{ 'centered-absolute': isBothActive, 'ms-auto me-auto': !isBothActive }"
    >
      <div class="d-flex align-items-center bg-light-danger border border-danger border-opacity-25 rounded px-3 py-2 shadow-xs">
        <div class="d-flex align-items-center me-3">
          <span class="badge badge-danger fw-bold fs-8 me-2 px-2 py-1 text-uppercase shadow-xs">
            <i class="fa-solid fa-briefcase text-white me-1 fs-8"></i> Lucrezi pe
          </span>

          <!-- Daca este firma de lucru selectata -->
          <div v-if="workStore.hasFirma" class="d-flex flex-column text-start me-2" style="max-width: 250px;">
            <span class="text-dark fw-bold fs-7 text-truncate lh-sm" :title="workStore.firmaDenumire">
              {{ workStore.firmaDenumire }}
            </span>
            <span class="text-danger fw-bold fs-8 mt-1 lh-1">
              CUI: {{ workStore.firmaCui || '-' }}
            </span>
          </div>

          <!-- Daca NU este firma selectata -->
          <div v-else class="me-2">
            <span class="text-danger fw-bold fs-7">Nicio firmă selectată</span>
          </div>
        </div>

        <button
          v-if="workStore.hasFirma"
          type="button"
          class="btn btn-sm btn-light-danger text-danger fw-bold py-1 px-2 d-flex align-items-center gap-1"
          @click="goToWorkSearch"
          title="Schimbă firma pe care lucrezi"
        >
          <i class="fa-solid fa-arrows-rotate fs-7"></i>
          <span class="fs-8 d-none d-md-inline">Schimbă</span>
        </button>

        <button
          v-else
          type="button"
          class="btn btn-sm btn-danger fw-bold py-1 px-3 fs-7"
          @click="goToWorkSearch"
          title="Selectează firma pentru lucru"
        >
          <i class="fa-solid fa-magnifying-glass me-1 fs-8"></i> Selectează
        </button>
      </div>
    </div>

    <!-- 2. WIDGET VERDE: FIRMA MEA (CLIENT) - ALINIAT LA DREAPTA -->
    <!-- Afișat dacă modul este 'client' sau 'tot' (sau pentru clienți standard) -->
    <div v-if="showClientSection" class="header-client-right d-flex align-items-center ms-auto">
      <div class="d-flex align-items-center bg-light-success border border-success border-opacity-25 rounded px-3 py-2 shadow-xs">
        <div class="d-flex align-items-center me-3">
          <span class="badge badge-success fw-bold fs-8 me-2 px-2 py-1 text-uppercase shadow-xs">
            <i class="fa-solid fa-building text-white me-1 fs-8"></i> Firma Mea
          </span>

          <div v-if="clientFirma" class="d-flex flex-column text-end me-2" style="max-width: 250px;">
            <span class="text-dark fw-bold fs-7 text-truncate lh-sm" :title="clientFirma.denumire">
              {{ clientFirma.denumire }}
            </span>
            <span class="text-success fw-bold fs-8 mt-1 lh-1">
              CUI: {{ clientFirma.cui || '-' }}
            </span>
          </div>
          <div v-else class="me-2">
            <span class="text-success fw-bold fs-7">Fără firmă activă</span>
          </div>
        </div>

        <button
          type="button"
          id="btn-schimba-firma"
          class="btn btn-sm btn-light-success text-success fw-bold py-1 px-2 d-flex align-items-center gap-1"
          @click="openClientSelectModal"
          title="Schimbă Firma Mea"
        >
          <i class="fa-solid fa-arrows-rotate fs-7"></i>
          <span class="fs-8 d-none d-md-inline">Schimbă</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from '../../stores/user';
import { useWorkFirmStore } from '../../stores/workFirmStore';

export default {
  name: 'AppHeaderFirmWidget',
  setup() {
    const userStore = useUserStore();
    const workStore = useWorkFirmStore();
    return { userStore, workStore };
  },
  computed: {
    canWork() {
      if (this.$gate && typeof this.$gate.canWorkOnFirms === 'function') {
        return this.$gate.canWorkOnFirms();
      }
      return this.$gate?.isAdmin() || false;
    },
    clientFirma() {
      const u = this.userStore.user;
      if (u?.firma_curenta && typeof u.firma_curenta === 'object') {
        return u.firma_curenta;
      }
      if (this.userStore.firmaCurenta && typeof this.userStore.firmaCurenta === 'object') {
        return this.userStore.firmaCurenta;
      }
      if (window.initialUserData?.firma_curenta && typeof window.initialUserData.firma_curenta === 'object') {
        return window.initialUserData.firma_curenta;
      }
      return null;
    },
    showClientSection() {
      if (!this.canWork) return true;
      const mode = this.userStore.currentSidebarMode || 'tot';
      return mode === 'client' || mode === 'tot';
    },
    showContabilSection() {
      if (!this.canWork) return false;
      const mode = this.userStore.currentSidebarMode || 'tot';
      return mode === 'contabil' || mode === 'tot';
    },
    isBothActive() {
      return this.showContabilSection && this.showClientSection;
    }
  },
  methods: {
    openClientSelectModal() {
      window.dispatchEvent(new Event('open-modal-schimba-firme'));
    },
    goToWorkSearch() {
      this.workStore.clearFirma();
      if (this.$route?.path !== '/administrare/work') {
        this.$router.push('/administrare/work').catch(() => {});
      }
    }
  }
};
</script>

<style scoped>
.header-firm-container {
  min-height: 48px;
}
.centered-absolute {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
.shadow-xs {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.fs-7 {
  font-size: 0.95rem !important;
}
.fs-8 {
  font-size: 0.82rem !important;
}
.fs-9 {
  font-size: 0.72rem !important;
}

@media (max-width: 991px) {
  .centered-absolute {
    position: static;
    transform: none;
    margin-right: 1rem;
  }
}
</style>
